import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export const ConfirmModal = ({
  title,
  description,
  confirmLabel = 'Confirm',
  confirmClassName = 'btn-primary',
  onConfirm,
  onCancel,
  icon = FiIcons.FiAlertTriangle,
  iconClassName = 'text-amber-500',
}) => (
  <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
    <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-in">
      <div className="flex flex-col items-center text-center mb-6">
        <div className="w-14 h-14 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center mb-4">
          <SafeIcon icon={icon} className={`text-2xl ${iconClassName}`} />
        </div>
        <h3 className="text-lg font-bold text-brand-navy mb-2">{title}</h3>
        <p className="text-sm text-slate-600 leading-relaxed">{description}</p>
      </div>

      <div className="flex gap-3">
        <button
          onClick={onCancel}
          className="btn-secondary flex-1"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className={`${confirmClassName} flex-1`}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
);